import { Notification } from '@/plugins/notifications'
import { useAuthAdminStore } from '@/stores/AuthAdminStore'

export const AuthAdminGuard = (to, from, next) => {
  const authAdminStore = useAuthAdminStore()

  if (to.meta.requiresAuth && !authAdminStore.isAuthenticated) {
    return next('/admin/login')
  }

  if ( to.meta.requiresAuth && authAdminStore.isAuthenticated && authAdminStore.isCustomer) {
    Notification.error('Acesso negado')
    authAdminStore.logout()
    return
  }

  next()
}

export const LoginAdminGuard = (to, from, next) => {
  const authAdminStore = useAuthAdminStore()

  if (!authAdminStore.isAuthenticated) {
    next()
  } else {
    next('/admin')
  }
}
